import { VideoChaptersMenuContent } from './video-chapters-menu-content'

const { videojs } = global
const Menu = videojs.getComponent('Menu')

/**
 * This layer is needed to:
 * - use standard MenuButton
 * - add a transparent panel above the video progress bar
 * @class
 * @extends Menu
 */
// eslint-disable-next-line import/prefer-default-export
export class VideoChaptersMenu extends Menu {
  /**
   * @param {Player|Object} player
   * @param {Object} options
   * @param {Object} options.menuButton reference to menuButton context
   * @returns {void}
   */
  constructor (player, options) {
    super(player, {
      ...options,
      contentElType: 'div',
      className: 'vjs-chapters-menu',
    })

    const content = new VideoChaptersMenuContent(this.player())
    this.addChild(content)
  }
}
